import BankAccountsService from "@/services/BankAccountsService";
import { replaceItemInList, removeItemFromList } from "@/utils/listHelpers";
import { notifyStoreError } from "@/utils/storeHelpers";
const errorMessages = {
    list: 'Erro ao buscar as contas bancárias. Tente novamente.',
    create: 'Erro ao adicionar a conta bancária. Tente novamente.',
    update: 'Erro ao atualizar a conta bancária. Tente novamente.',
    delete: 'Erro ao excluir a conta bancária. Tente novamente.',
    toggle: 'Erro ao alterar o status da conta bancária. Tente novamente.',
};
export default {
    namespaced: true,
    state: {
        bankAccountsData: [],
        status: null,
    },
    getters: {
        getBankAccountsData: (state) => {
            if (Array.isArray(state.bankAccountsData))
                return state.bankAccountsData;
            if (state.bankAccountsData && state.bankAccountsData.data)
                return state.bankAccountsData.data;
            return [];
        },
        getStatus: (state) => state.status,
    },
    mutations: {
        setBankAccountsData(state, data) {
            state.bankAccountsData = data;
        },
        setStatus(state, status) {
            state.status = status;
        },
        createBankAccountInList(state, bankAccount) {
            if (!bankAccount)
                return;
            if (Array.isArray(state.bankAccountsData)) {
                state.bankAccountsData.push(bankAccount);
            }
            else if (state.bankAccountsData?.data && Array.isArray(state.bankAccountsData.data)) {
                state.bankAccountsData.data.push(bankAccount);
            }
        },
    },
    actions: {
        async getBankAccounts({ commit, dispatch }, payload) {
            try {
                const response = await BankAccountsService.getBankAccounts(payload.data, payload.userToken);
                commit('setBankAccountsData', response.data);
            }
            catch (error) {
                commit('setStatus', errorMessages.list);
                notifyStoreError(dispatch, errorMessages.list, error);
            }
            finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true });
                }
            }
        },
        async createBankAccount({ commit, dispatch }, payload) {
            try {
                const response = await BankAccountsService.createBankAccount(payload.data, payload.userToken);
                commit('createBankAccountInList', response.data);
                dispatch('toastfy/activeSuccesNotification', { text: 'Conta bancária adicionada com sucesso' }, { root: true });
                return response.data;
            }
            catch (error) {
                return notifyStoreError(dispatch, errorMessages.create, error);
            }
        },
        async updateBankAccount({ commit, state, dispatch }, payload) {
            try {
                const response = await BankAccountsService.updateBankAccount(payload.data, payload.userToken);
                dispatch('toastfy/activeSuccesNotification', { text: 'Conta bancária atualizada com sucesso' }, { root: true });
                commit('setBankAccountsData', replaceItemInList(state.bankAccountsData, response.data));
                return response.data;
            }
            catch (error) {
                return notifyStoreError(dispatch, errorMessages.update, error);
            }
        },
        async deleteBankAccount({ commit, state, dispatch }, payload) {
            try {
                await BankAccountsService.deleteBankAccount(payload.data, payload.userToken);
                dispatch('toastfy/activeSuccesNotification', { text: 'Conta bancária deletada com sucesso' }, { root: true });
                commit('setBankAccountsData', removeItemFromList(state.bankAccountsData, payload.data));
            }
            catch (error) {
                notifyStoreError(dispatch, errorMessages.delete, error);
            }
        },
        async toggleBankAccountActive({ commit, state, dispatch }, payload) {
            try {
                const response = await BankAccountsService.toggleBankAccountActive(payload.data, payload.userToken);
                dispatch('toastfy/activeSuccesNotification', { text: 'Status da conta bancária atualizado com sucesso' }, { root: true });
                commit('setBankAccountsData', replaceItemInList(state.bankAccountsData, response.data));
                return response.data;
            }
            catch (error) {
                return notifyStoreError(dispatch, errorMessages.toggle, error);
            }
        },
    }
};
